import { useState } from 'react';

import { PocButton, PocMenu } from 'commons/components/components-wrapper';

interface DropdownButtonWithMenuProps {
    id: string;
    buttonContent: (visible: boolean) => React.ReactNode;
    menuContent: React.ReactNode;
    position?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';
    offset?: [number, number];
    autoCloseOnSelection?: boolean;
    strategy?: 'absolute' | 'fixed';
    trigger?: 'click' | 'hover';
    initiallyVisible?: boolean;
    onVisibilityChange?: (visible: boolean) => void;
    variant?: 'primary' | 'secondary' | 'tertiary';
    buttonProps?: React.ComponentProps<typeof PocButton> & { 'data-testid'?: string };
}

export const DropdownButtonWithMenu: React.FC<DropdownButtonWithMenuProps> = ({
    id,
    buttonContent,
    menuContent,
    position = 'bottom-start',
    offset = [0, 12],
    autoCloseOnSelection = true,
    strategy,
    trigger = 'click',
    initiallyVisible = false,
    onVisibilityChange,
    variant = 'secondary',
    buttonProps = {},
}) => {
    const [visible, setVisible] = useState(initiallyVisible);

    const handleVisibilityChange = (ev: CustomEvent<boolean>) => {
        setVisible(ev.detail);
        onVisibilityChange?.(ev.detail);
    };

    const visibleFalseHandler = () => setVisible(false);

    return (
        <>
            <PocButton id={id} variant={variant} {...buttonProps}>
                {buttonContent(visible)}
            </PocButton>
            <PocMenu
                anchor={id}
                data-testid={`${id}-menu`}
                trigger={trigger}
                position={position}
                offset={offset}
                {...(strategy ? { strategy } : {})}
                visible={visible}
                onVisibleChange={handleVisibilityChange}
                onClickOutside={visibleFalseHandler}
                onMouseLeave={visibleFalseHandler}
                autoCloseOnSelection={autoCloseOnSelection}
            >
                {menuContent}
            </PocMenu>
        </>
    );
};
